import { ReactElement, useMemo } from 'react';
import { IdentityProvider, GetOrganizationResponse } from '@localstack/types';

import { IdpListEntry } from './IdpListEntry';

type Props = {
  identityProviders: IdentityProvider[];
  selectedProviderName?: string | null;
  organization?: Optional<GetOrganizationResponse>;
  showScimSection: boolean;
  isIdpLoading: boolean;
  isAnotherScimEnabled: boolean;
  isAnyScimToggleLoading: boolean;
  onSelectProvider: (idp: IdentityProvider) => void;
  onOpenScimConfig: (idpName: string) => void;
  onToggleScim: (idpName: string, checked: boolean) => Promise<void>;
  getScimToggleLoading?: (idpName: string) => boolean;
};

export const IdpList = ({
  identityProviders,
  selectedProviderName,
  organization,
  showScimSection,
  isIdpLoading,
  isAnyScimToggleLoading,
  getScimToggleLoading,
  onSelectProvider,
  onOpenScimConfig,
  onToggleScim,
}: Props): ReactElement => {
  const idpNameSet = useMemo(() => new Set(identityProviders.map((p) => p.idp_name)), [identityProviders]);

  return (
    <>
      {identityProviders.map((idp, index) => {
        const isSelected = idp?.idp_name === selectedProviderName;
        const isScimToggleLoading = idp?.idp_name ? !!getScimToggleLoading?.(idp.idp_name) : false;

        return (
          <IdpListEntry
            key={idp?.idp_name ?? `idp-${index}`}
            idp={idp}
            isSelected={isSelected}
            onSelectProvider={onSelectProvider}
            organization={organization}
            showScimSection={showScimSection}
            isIdpLoading={isIdpLoading}
            isScimToggleLoading={isScimToggleLoading}
            isAnyScimToggleLoading={isAnyScimToggleLoading}
            onOpenScimConfig={onOpenScimConfig}
            onToggleScim={onToggleScim}
            existingIdpNames={idpNameSet}
          />
        );
      })}
    </>
  );
};
